<template>
  <toggle-button
    v-if="content && content.contentvalue != undefined"
    class="mt-2"
    :value="content.contentvalue"
    :sync="true"
    :color="$vuetify.theme.success"
    @change="onSwitch"
    :labels="{ checked: 'ON', unchecked: 'OFF' }"
    style="display: inline-block"
  />
</template>

<script>
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  props: ['value'],
  data: function() {
    return {
      content: this.value
    }
  },
  methods: {
    onSwitch: function() {
      let vm = this
      vm.content.contentvalue = !vm.content.contentvalue

      api.updateConfig(vm.content, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    }
  },
  watch: {
    value: function() {
      this.content = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/setting/input-no-label/InputBooleanNoLabel.vue